import { CALCULATOR_MODE } from '../../@types/travel';
import Radio from '../inputs/Radio';

//
//

type FlightModeNavigationProps = {
  calculatorMode: string;
  setCalculatorMode: (mode: string) => void;
  useTravelTime?: boolean;
};

//

export const FlightModeNavigation: React.FC<FlightModeNavigationProps> = ({
  calculatorMode,
  setCalculatorMode,
  useTravelTime,
}) => {
  //

  return (
    <div style={{ display: 'flex', gap: '1rem' }}>
      <Radio
        onChange={(value) => setCalculatorMode(value)}
        calculatorMode={calculatorMode}
        value={CALCULATOR_MODE.return}
        label={CALCULATOR_MODE.return}
      />

      <Radio
        onChange={(value) => setCalculatorMode(value)}
        calculatorMode={calculatorMode}
        value={CALCULATOR_MODE.oneway}
        label={CALCULATOR_MODE.oneway}
      />

      {!useTravelTime && (
        <Radio
          onChange={(value) => setCalculatorMode(value)}
          calculatorMode={calculatorMode}
          value={CALCULATOR_MODE.multicity}
          label={CALCULATOR_MODE.multicity}
        />
      )}
    </div>
  );
};
